export default "__VITE_ASSET__5ff03cb9__"